import React, {Fragment} from 'react'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'
import {withStyles} from 'material-ui/styles'
import Grid from 'material-ui/Grid'
import styles from './styles'
import {ModalContents, ModalFooter, ModalHeader} from '../modal'
import {FormControl, FormControlLabel, FormLabel} from "material-ui/Form";
import Radio, {RadioGroup} from "material-ui/Radio";
import TextField from "material-ui/TextField";

class MFADialog extends React.Component {

  state = {
    otpSent: false, sendVia: 'email', otp: '', errors: {}, mfaVerified: false
  }

  handleChange = (name) => event => {
    if (name === 'sendVia') {
      this.setState({sendVia: event.target.value})
    }

    if (name === 'otp') {
      this.setState({otp: event.target.value})
    }
  }


  sendOTP() {
    const {sendOtp} = this.props

    sendOtp({
      method: this.state.sendVia,
    });

    this.setState({otpSent: true})
  }

  verifyOTP() {

    const {verifyOtp} = this.props

    verifyOtp({
      otp: this.state.otp,
    })
  }

  render() {

    const {
      classes, open, closeMfaDialog, translate, mfaError
    } = this.props
    return (<Modal
      open={open}
      onClose={this.closeMfaDialog}
    >
      <div className={classes.root}>
        <Paper className={classes.modal}>
          <ModalHeader>
            <Typography type="headline" color="inherit"
                        className={classes.modalHeader}>
              {translate('mfa_dialog_title')}
            </Typography>
            <Button
              className={classes.close}
              onClick={() => closeMfaDialog()}
            >
              <Icon>clear</Icon>
            </Button>
          </ModalHeader>

          <ModalContents>
            <Grid container spacing={8} className={classes.form}>
              <Grid item xs={12} className={classes.formChild}>
                <Typography type="body1" className={classes.instruction}>
                  {translate('mfa_instruction')}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.formChild}>
                <FormControl component="fieldset">
                  <FormLabel>{translate('mfa_send_via')}</FormLabel>
                  <RadioGroup
                    aria-label="send-via"
                    name="sendVia"
                    row
                    value={this.state.sendVia}
                    onChange={this.handleChange('sendVia')}
                  >
                    <FormControlLabel value="email" control={<Radio/>}
                                      label={translate('mfa_send_via_email')}/>
                    {/*<FormControlLabel value="text" control={<Radio/>}*/}
                    {/*                  label={translate('mfa_send_via_text')}/>*/}
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} className={classes.formChild}>
                {mfaError && <Typography type="body1" color="error">
                  {translate('mfa_invalid_otp')} </Typography>}
              </Grid>
            </Grid>
          </ModalContents>
          <ModalFooter>
            <div className={classes.actions}>

              {!this.state.otpSent && <Button
                type="button"
                color="primary"
                raised
                onClick={(e) => this.sendOTP(e)}
              >
                {translate('mfa_send_otp')}
              </Button>}
              {this.state.otpSent && <Fragment>
                <TextField
                  autoFocus={true}
                  required
                  id="otp"
                  label={translate('mfa_enter_otp')}
                  className={classes.textField}
                  onChange={this.handleChange('otp')}
                  value={this.state.otp}
                />
                <Button
                  type="button"
                  color="primary"
                  raised
                  onClick={() => this.verifyOTP()}
                >
                  {translate('mfa_verify_otp')}
                </Button>
              </Fragment>}
            </div>
          </ModalFooter>
        </Paper>
      </div>
    </Modal>)
  }
}

export default withStyles(styles)(MFADialog)



// WEBPACK FOOTER //
// ./src/components/common/mfaDialog/index.js